import React from "react";

const ClinicianRegistrationScreen = ({ children }) => (
  <div className="gip-modal-wrapper clinician-onboard-screen">
    <div className="gip-modal-content">{children}</div>
  </div>
);

export default ClinicianRegistrationScreen;
